{
  "version": 1,
  "asset_id": "cee96061-3dc3-4a8c-887f-93505e9bc084",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/cee96061-3dc3-4a8c-887f-93505e9bc084/sleeve-gastrectomy-es-v2-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/cee96061-3dc3-4a8c-887f-93505e9bc084/sleeve-gastrectomy-es-v2-1200.jpg",
  "original_filename": "sleeve-gastrectomy-es-v2-1200.jpg",
  "size": 113610,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:06:27Z"
}
